import { render, staticRenderFns } from "./Toexamine.vue?vue&type=template&id=34821fae&scoped=true&"
import script from "./Toexamine.vue?vue&type=script&lang=js&"
export * from "./Toexamine.vue?vue&type=script&lang=js&"
import style0 from "./Toexamine.vue?vue&type=style&index=0&id=34821fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34821fae",
  null
  
)

export default component.exports